import { subtitleLandingLight } from "assets/jss/material-kit-pro-react";
import { whiteColor } from "assets/jss/material-kit-pro-react";
import { subtitleLandingBold } from "assets/jss/material-kit-pro-react";

const style = (theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingTop: "25px",
    paddingBottom: "25px",
    paddingLeft: "150px",
    paddingRight: "150px",
    backgroundColor: "#1B2A31",
    borderRadius: "5px",
    zIndex: "2",
    [theme.breakpoints.down("lg")]: {
      marginRight: "48px",
      marginLeft: "48px",
    },
    [theme.breakpoints.down("sm")]: {
      marginRight: "48px",
      marginLeft: "48px",
    },
    [theme.breakpoints.down("xs")]: {
      marginRight: "32px",
      marginLeft: "32px",
    },
  },
  title: {
    color: whiteColor,
    ...subtitleLandingBold,
    marginBottom: "100px",
    [theme.breakpoints.down("sm")]: {
      marginBottom: "25px"
    },
    [theme.breakpoints.down("xs")]: {
      marginBottom: "10px"
    },
    textAlign: "center",
  },
  bonusContainer: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center",
    maxWidth: "1200px",
  },
  bonusItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    position: "relative",
    padding: "20px",
    
    [theme.breakpoints.up("md")]: {
      width: "25%", // 4 items en fila
      "&:not(:last-child)::after": {
        content: "''",
        position: "absolute",
        top: "20%",
        bottom: "20%",
        right: 0,
        width: "1px",
        backgroundColor: "#1E3844",
      },
    },

    [theme.breakpoints.down("sm")]: {
      width: "50%",

      "&:nth-child(odd)::after": {
        content: "''",
        position: "absolute",
        top: "20%",
        bottom: "20%",
        right: 0,
        width: "1px",
        backgroundColor: "#1E3844",
      },

      "&:nth-child(-n+2)::before": {
        content: "''",
        position: "absolute",
        bottom: 0,
        left: "20%",
        right: "20%",
        height: "1px",
        backgroundColor: "#1E3844",
      },
    },

    [theme.breakpoints.down("xs")]: {
      width: "100%",
      "&:after": {
        display: "none",
      },
      "&:before": {
        display: "none",
      },
    },
  },

  bonusItemText: {
    ...subtitleLandingLight,
    color: whiteColor
  },
});


export default style;